<template>
  <section role="complementary" :class="[cssClass]" :id="`${cssClass}-${id}`">
    <slot />
    <div :class="[`${cssClass}-backdrop`]" aria-hidden="true" :style="{backgroundImage: `url(${backdrop})`}" />
    <vc-style>
    #{{ cssClass }}-{{ id }} {
      color: {{ color }};
      background-color: {{ bgColor }};
    }
    </vc-style>
  </section>
</template>
<script>
import VcStyle from './style'
import uuid from 'uuid/v4'

export default {
  name: 'VcParallaxSection',
  components: {
    VcStyle
  },
  data () {
    return {
      id: uuid(),
      cssClass: `${this.$parent.cssClass}-section`
    }
  },
  props: {
    /**
     * URL of the section background
     */
    backdrop: {
      type: String,
      required: false
    },
    /**
     * Background color of a static section
     */
    bgColor: {
      type: String,
      required: false,
      default: '#282828'
    },
    /**
     * Default color of the section
     */
    color: {
      type: String,
      required: false,
      default: '#fff'
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    /**
     * Handler for the mounted callback of the component
     * @method onMounted
     * @return {void}
     */
    onMounted () {
      if (!this.$parent.$el.classList.contains('vc-parallax')) {
        console.error('The <vc-parallax-section /> element should be nested inside of a <vc-parallax /> component.')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// section.vue?d8f450b2